import ContentStorePage from 'components/ContentStore/ContentStorePage';
import { withContentStoreProps } from 'viewModel/contentStore/withContentStoreProps';

export default withContentStoreProps(ContentStorePage);
